(function () {
  var shouldOpenCartDrawerAfterAdd = false;
  var cartDrawerFallbackTimer = null;

  function openCartDrawer() {
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    var cartTrigger = document.querySelector('[aria-controls="cart-drawer"], [data-testid="cart-drawer-trigger"]');
    if (cartTrigger && typeof cartTrigger.click === 'function') {
      cartTrigger.click();
      return;
    }

    if (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) {
      window.location.href = window.Theme.routes.cart_url;
      return;
    }

    window.location.href = '/cart';
  }

  function scheduleCartDrawerFallback() {
    if (cartDrawerFallbackTimer) window.clearTimeout(cartDrawerFallbackTimer);
    cartDrawerFallbackTimer = window.setTimeout(function () {
      if (!shouldOpenCartDrawerAfterAdd) return;
      openCartDrawer();
    }, 450);
  }

  function getJudgeMeWriteButton() {
    var selectors = [
      '#judgeme_product_reviews .jdgm-write-rev-link',
      '#judgeme_product_reviews .jdgm-rev-widg__write-btn',
      '#judgeme_product_reviews .jdgm-rev-widg__write-review',
      '#judgeme_product_reviews .jdgm-write-rev-btn',
      '#judgeme_product_reviews .jdgm-btn[data-action="write-review"]',
      '#judgeme_product_reviews [data-widget="review"] .jdgm-write-rev-link',
    ];

    var buttons = document.querySelectorAll(selectors.join(','));
    for (var index = 0; index < buttons.length; index += 1) {
      var button = buttons[index];
      if (button) return button;
    }

    var candidates = document.querySelectorAll('#judgeme_product_reviews a, #judgeme_product_reviews button');
    for (var candidateIndex = 0; candidateIndex < candidates.length; candidateIndex += 1) {
      var candidate = candidates[candidateIndex];
      var label = (candidate.textContent || candidate.getAttribute('aria-label') || '').trim().toLowerCase();
      if (label.indexOf('write') !== -1 && label.indexOf('review') !== -1) return candidate;
    }

    return document.querySelector('.jdgm-write-rev-link, .jdgm-rev-widg__write-btn, .jdgm-write-rev-btn');
  }

  function prepareJudgeMeWriteButton(writeButton) {
    if (!writeButton) return;
    writeButton.removeAttribute('hidden');
    writeButton.removeAttribute('aria-hidden');
    if (writeButton.style.display !== 'inline-flex') writeButton.style.display = 'inline-flex';
    if (writeButton.style.visibility !== 'visible') writeButton.style.visibility = 'visible';
    if (writeButton.style.opacity !== '1') writeButton.style.opacity = '1';
  }

  function scrollToJudgeMeWidget() {
    var widget = document.querySelector('#judgeme_product_reviews');
    if (!widget) return;
    widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function openJudgeMeReviewForm() {
    var attempts = 0;
    var maxAttempts = 20;

    function tryOpen() {
      var writeButton = getJudgeMeWriteButton();
      if (writeButton) {
        prepareJudgeMeWriteButton(writeButton);
        writeButton.click();
        return;
      }

      attempts += 1;
      if (attempts < maxAttempts) {
        window.setTimeout(tryOpen, 150);
        return;
      }

      scrollToJudgeMeWidget();
    }

    scrollToJudgeMeWidget();
    tryOpen();
  }

  function setGallery(gallery, nextIndex) {
    var slides = gallery.querySelectorAll('[data-yt-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-yt-gallery-thumb]');
    if (!slides.length) return;

    var normalized = (nextIndex + slides.length) % slides.length;
    slides.forEach(function (slide, index) {
      slide.classList.toggle('is-active', index === normalized);
    });
    thumbs.forEach(function (thumb, index) {
      thumb.classList.toggle('is-active', index === normalized);
      thumb.setAttribute('aria-current', index === normalized ? 'true' : 'false');
    });

    var activeThumb = thumbs[normalized];
    if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
      activeThumb.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
    }

    var counter = gallery.querySelector('[data-yt-gallery-current]');
    if (counter) counter.textContent = String(normalized + 1).padStart(2, '0');
    gallery.dataset.activeIndex = String(normalized);
    gallery.classList.remove('is-zoomed');
    var zoomButton = gallery.querySelector('[data-yt-gallery-zoom]');
    if (zoomButton) {
      zoomButton.classList.remove('is-active');
      zoomButton.setAttribute('aria-pressed', 'false');
      zoomButton.setAttribute('aria-label', 'Zoom product image');
    }
  }

  function syncGalleryToVariant(productSection, variant) {
    var mediaId = variant && variant.featured_media && variant.featured_media.id;
    if (!productSection || !mediaId) return;

    var gallery = productSection.querySelector('[data-yt-product-gallery]');
    if (!gallery) return;

    var mediaIdString = String(mediaId);
    var matchingSlide = Array.from(gallery.querySelectorAll('[data-yt-gallery-slide][data-yt-media-id]')).find(function (slide) {
      return slide.dataset.ytMediaId === mediaIdString;
    });
    if (!matchingSlide) return;

    var nextIndex = Number(matchingSlide.dataset.ytGallerySlide);
    var currentIndex = Number(gallery.dataset.activeIndex || 0);
    if (!Number.isFinite(nextIndex) || nextIndex === currentIndex) return;

    setGallery(gallery, nextIndex);
  }

  function getActiveGalleryImage(gallery) {
    return gallery?.querySelector('.yt-product-gallery__slide.is-active img');
  }

  function toggleGalleryZoom(gallery) {
    if (!gallery) return;
    var isZoomed = gallery.classList.toggle('is-zoomed');
    var zoomButton = gallery.querySelector('[data-yt-gallery-zoom]');
    if (zoomButton) {
      zoomButton.classList.toggle('is-active', isZoomed);
      zoomButton.setAttribute('aria-pressed', isZoomed ? 'true' : 'false');
      zoomButton.setAttribute('aria-label', isZoomed ? 'Reset product image zoom' : 'Zoom product image');
    }
  }

  function openGalleryLightbox(gallery) {
    if (!gallery) return;

    var activeImage = getActiveGalleryImage(gallery);
    var lightbox = gallery.querySelector('[data-yt-gallery-lightbox]') || document.querySelector('[data-yt-gallery-lightbox]');
    var lightboxImage = gallery.querySelector('[data-yt-gallery-lightbox-image]');
    if (!lightboxImage && lightbox) lightboxImage = lightbox.querySelector('[data-yt-gallery-lightbox-image]');
    if (!activeImage || !lightbox || !lightboxImage) return;

    lightboxImage.src = activeImage.currentSrc || activeImage.src;
    lightboxImage.alt = activeImage.alt || '';
    if (lightbox.parentElement !== document.body) document.body.appendChild(lightbox);
    lightbox.hidden = false;
    document.body.classList.add('yt-gallery-lightbox-open');
    lightbox.querySelector('[data-yt-gallery-lightbox-close]')?.focus();
  }

  function closeGalleryLightbox() {
    var openLightbox = document.querySelector('[data-yt-gallery-lightbox]:not([hidden])');
    if (!openLightbox) return;

    openLightbox.hidden = true;
    document.body.classList.remove('yt-gallery-lightbox-open');
  }

  function getCurrencyDivisor(currency) {
    var zeroDecimalCurrencies = ['BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA', 'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF'];
    var threeDecimalCurrencies = ['BHD', 'JOD', 'KWD', 'OMR', 'TND'];
    var normalizedCurrency = String(currency || '').toUpperCase();

    if (zeroDecimalCurrencies.indexOf(normalizedCurrency) !== -1) return 1;
    if (threeDecimalCurrencies.indexOf(normalizedCurrency) !== -1) return 1000;
    return 100;
  }

  function formatCents(cents, thousandsSeparator, decimalSeparator, precision, divisor) {
    var value = Math.max(0, Number(cents) || 0) / divisor;
    var fixed = value.toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

    if (precision <= 0) return dollars;
    return dollars + decimalSeparator + (parts[1] || '').padEnd(precision, '0');
  }

  function formatMoney(cents, format, currency) {
    var divisor = getCurrencyDivisor(currency);
    var precision = divisor === 1 ? 0 : divisor === 1000 ? 3 : 2;

    return String(format || '{{amount}}').replace(/{{\s*(\w+)\s*}}/g, function (_, placeholder) {
      var thousandsSeparator = ',';
      var decimalSeparator = '.';
      var nextPrecision = precision;

      if (placeholder === 'currency') return currency || '';
      if (placeholder === 'amount_no_decimals') nextPrecision = 0;
      if (placeholder === 'amount_with_comma_separator') {
        thousandsSeparator = '.';
        decimalSeparator = ',';
      }
      if (placeholder === 'amount_no_decimals_with_comma_separator') {
        thousandsSeparator = '.';
        nextPrecision = 0;
      }
      if (placeholder === 'amount_no_decimals_with_space_separator') {
        thousandsSeparator = ' ';
        nextPrecision = 0;
      }
      if (placeholder === 'amount_with_space_separator') {
        thousandsSeparator = ' ';
        decimalSeparator = ',';
      }
      if (placeholder === 'amount_with_period_and_space_separator') {
        thousandsSeparator = ' ';
        decimalSeparator = '.';
      }
      if (placeholder === 'amount_with_apostrophe_separator') {
        thousandsSeparator = "'";
        decimalSeparator = '.';
      }

      return formatCents(cents, thousandsSeparator, decimalSeparator, nextPrecision, divisor);
    });
  }

  function getProductQuantity(button) {
    var form = button.closest('.yt-product-form');
    var input = form?.querySelector('input[name="quantity"]');
    return Math.max(1, Number(input?.value || 1));
  }

  function getMainQuantityInput() {
    return document.querySelector('.yt-product-form input[name="quantity"]');
  }

  function syncStickyQuantity(quantity) {
    var nextQuantity = Math.max(1, Number(quantity || getMainQuantityInput()?.value || 1));

    document.querySelectorAll('[data-yt-sticky-quantity-value]').forEach(function (value) {
      value.textContent = String(nextQuantity);
    });

    document.querySelectorAll('sticky-add-to-cart [ref="quantityNumber"]').forEach(function (value) {
      value.textContent = String(nextQuantity);
    });

    document.querySelectorAll('sticky-add-to-cart [ref="quantityDisplay"]').forEach(function (display) {
      display.style.display = nextQuantity > 1 ? 'inline' : 'none';
    });
  }

  function setMainQuantity(quantity) {
    var input = getMainQuantityInput();
    if (!input) return;

    var min = Math.max(1, Number(input.min || input.getAttribute('min') || 1));
    var max = Number(input.max || input.getAttribute('max') || 0);
    var step = Math.max(1, Number(input.step || input.getAttribute('step') || 1));
    var nextQuantity = Math.max(min, Number(quantity || min));

    if (max > 0) nextQuantity = Math.min(max, nextQuantity);
    nextQuantity = Math.round(nextQuantity / step) * step;

    input.value = String(nextQuantity);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    var quantityComponent = input.closest('quantity-selector-component');
    if (quantityComponent && typeof quantityComponent.updateButtonStates === 'function') {
      quantityComponent.updateButtonStates();
    }

    syncStickyQuantity(nextQuantity);
    updateMainAddToCartTotal();
  }

  function updateAddToCartTotal(button, variantPrice) {
    if (!button) return;

    var label = button.querySelector('.yt-product-form__add-label');
    var baseText = button.dataset.ytAtcBase || (label?.textContent || 'Add to cart').split(' - ')[0];
    var price = Number(variantPrice || button.dataset.ytVariantPrice || 0);

    if (!label || !price || button.disabled) {
      if (label && baseText) label.textContent = baseText;
      return;
    }

    button.dataset.ytVariantPrice = String(price);
    label.textContent = baseText + ' - ' + formatMoney(price * getProductQuantity(button), button.dataset.ytMoneyFormat, button.dataset.ytCurrency);
  }

  function updateMainAddToCartTotal(variantPrice) {
    updateAddToCartTotal(document.querySelector('.yt-product-info .yt-product-form__add'), variantPrice);
  }

  function updateSelectedOptionLabel(input) {
    if (!input) return;
    var fieldset = input.closest('.yt-product-options__group');
    if (!fieldset) return;

    var selectedValue = fieldset.querySelector('.yt-product-options__value');
    var optionText = input.closest('.variant-option__button-label')?.querySelector('.variant-option__button-label__text');
    var nextValue = (optionText?.textContent || input.value || '').trim();

    if (selectedValue && nextValue) selectedValue.textContent = nextValue;
  }

  document.addEventListener('click', function (event) {
    var judgeMeTrigger = event.target.closest('[data-yt-judgeme-write-trigger]');
    if (judgeMeTrigger) {
      event.preventDefault();
      openJudgeMeReviewForm();
      return;
    }

    var thumb = event.target.closest('[data-yt-gallery-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-yt-product-gallery]');
      if (gallery) setGallery(gallery, Number(thumb.dataset.ytGalleryThumb || 0));
      return;
    }

    var next = event.target.closest('[data-yt-gallery-next]');
    var prev = event.target.closest('[data-yt-gallery-prev]');
    if (next || prev) {
      var navGallery = event.target.closest('[data-yt-product-gallery]');
      if (!navGallery) return;
      var current = Number(navGallery.dataset.activeIndex || 0);
      setGallery(navGallery, current + (next ? 1 : -1));
      return;
    }

    var zoom = event.target.closest('[data-yt-gallery-zoom]');
    if (zoom) {
      toggleGalleryZoom(event.target.closest('[data-yt-product-gallery]'));
      return;
    }

    var expand = event.target.closest('[data-yt-gallery-expand]');
    if (expand) {
      openGalleryLightbox(event.target.closest('[data-yt-product-gallery]'));
      return;
    }

    var lightboxClose = event.target.closest('[data-yt-gallery-lightbox-close]');
    var lightboxBackdrop = event.target.matches?.('[data-yt-gallery-lightbox]');
    if (lightboxClose || lightboxBackdrop) {
      closeGalleryLightbox();
      return;
    }

    var stickyQuantityButton = event.target.closest('[data-yt-sticky-quantity-minus], [data-yt-sticky-quantity-plus]');
    if (stickyQuantityButton) {
      var quantityInput = getMainQuantityInput();
      var currentQuantity = Math.max(1, Number(quantityInput?.value || 1));
      var step = Math.max(1, Number(quantityInput?.step || quantityInput?.getAttribute('step') || 1));
      setMainQuantity(currentQuantity + (stickyQuantityButton.matches('[data-yt-sticky-quantity-plus]') ? step : -step));
      return;
    }

    var close = event.target.closest('[data-yt-sticky-close]');
    if (close) {
      var sticky = close.closest('sticky-add-to-cart');
      if (sticky) sticky.dataset.ytHidden = 'true';
    }
  });

  document.addEventListener('change', function (event) {
    var optionInput = event.target.closest('.yt-product-options__group input[type="radio"]');
    if (!optionInput || !optionInput.checked) return;
    updateSelectedOptionLabel(optionInput);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeGalleryLightbox();
  });

  document.addEventListener('quantity-selector:update', function (event) {
    if (!event.target.closest || !event.target.closest('.yt-product-form')) return;
    syncStickyQuantity();
    updateMainAddToCartTotal();
  });

  document.addEventListener('input', function (event) {
    if (!event.target.closest || !event.target.closest('.yt-product-form input[name="quantity"]')) return;
    syncStickyQuantity(event.target.value);
    updateMainAddToCartTotal();
  });

  document.addEventListener('shopify:product:select', function (event) {
    var promise = event.promise;
    if (!promise || typeof promise.then !== 'function') return;

    var productSection = event.target.closest('.yt-main-product');

    promise.then(function (result) {
      var variant = result && result.detail && result.detail.resource;
      syncGalleryToVariant(productSection, variant);
      window.setTimeout(function () {
        syncStickyQuantity();
        updateMainAddToCartTotal(variant && variant.price);
      }, 0);
    });
  });

  document.addEventListener(
    'submit',
    function (event) {
      if (!event.target.closest || !event.target.closest('.yt-product-form form')) return;
      shouldOpenCartDrawerAfterAdd = true;
      scheduleCartDrawerFallback();
    },
    true
  );

  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (!shouldOpenCartDrawerAfterAdd || event.action !== 'add') return;

    if (cartDrawerFallbackTimer) window.clearTimeout(cartDrawerFallbackTimer);
    window.requestAnimationFrame(openCartDrawer);

    var promise = event.promise;
    if (!promise || typeof promise.then !== 'function') {
      shouldOpenCartDrawerAfterAdd = false;
      return;
    }

    promise
      .then(function (result) {
        shouldOpenCartDrawerAfterAdd = false;
        if (result && result.detail && result.detail.didError) return;
      })
      .catch(function () {
        shouldOpenCartDrawerAfterAdd = false;
      });
  });

  function watchJudgeMeWidget() {
    var widget = document.querySelector('#judgeme_product_reviews');
    if (!widget || !window.MutationObserver) {
      prepareJudgeMeWriteButton(getJudgeMeWriteButton());
      return;
    }

    prepareJudgeMeWriteButton(getJudgeMeWriteButton());

    var observer = new MutationObserver(function () {
      prepareJudgeMeWriteButton(getJudgeMeWriteButton());
    });
    observer.observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden', 'class'] });

    window.setTimeout(function () {
      observer.disconnect();
    }, 10000);
  }

  window.setTimeout(watchJudgeMeWidget, 600);
  document.addEventListener('DOMContentLoaded', function () {
    window.setTimeout(watchJudgeMeWidget, 1200);
  });
})();
